import { memo } from 'react';
import { useParams } from 'react-router-dom';
import { FluidProgressIndicator } from '../../../core/components/ProgressIndicators';
import usePostPage from '../../queries/usePostPage';
import Container from '../../../core/components/Container';
import LinkBreadcrumbs from '../../../core/components/LinkBreadcrumbs';
import PageNotFound from '../../../core/components/router/PageNotFound';
import withErrorBoundary from '../../../core/components/errors/withErrorBoundary';
import styles from './PostPage.module.scss';
import PostPageContent from './PostPageContent';

const PostPage = () => {
    const { page } = useParams<{ page: string }>();
    const { data, loading } = usePostPage(`news/${page}`);

    const content = data ? <PostPageContent post={data} /> : <PageNotFound />;

    const breadcrumbs = data && [
        {
            labelId: 'news archive',
            to: '../',
            isRelative: true,
        },
        {
            label: data.content.title,
            to: '.',
            isRelative: true,
        },
    ];

    return (
        <>
            {breadcrumbs && (
                <LinkBreadcrumbs
                    title={
                        data.content.meta_fields?.title || data.content.title
                    }
                    description={data.content.meta_fields?.description}
                    breadcrumbs={breadcrumbs}
                />
            )}
            <Container>
                {loading ? (
                    <div className={styles.progressIndicatorContainer}>
                        <FluidProgressIndicator />
                    </div>
                ) : (
                    content
                )}
            </Container>
        </>
    );
};

export default memo(withErrorBoundary(PostPage));
